import React from 'react'
import { Avatar } from '@mui/material'
import { UserModel } from '../../models/UserModel'

interface UserAvatarProps {
    userModel: UserModel | null
    email: string
}

// name_given + name_family (first letter each) is preferred since it's unambiguous; userModel.name
// is a single free-text field that may be just a placeholder (e.g. the email's local part) until
// the user sets a real name, so it only ever contributes one letter, not two; email is the last
// resort for when userModel hasn't loaded yet.
const getUserInitials = (userModel: UserModel | null, email: string): string => {
    if (userModel?.name_given && userModel?.name_family) {
        return (userModel.name_given[0] + userModel.name_family[0]).toUpperCase()
    }
    if (userModel?.name) {
        return userModel.name.trim().charAt(0).toUpperCase()
    }
    return email ? email[0].toUpperCase() : ''
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ userModel, email }) => (
    <Avatar
        sx={{
            width: 32,
            height: 32,
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '0.3px',
        }}
    >
        {getUserInitials(userModel, email)}
    </Avatar>
)
